<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="560px"
      top="20vh"
      :show-close="true"
      :close-on-click-modal="false"
      :title="title"
      :before-close="handleClose">
      <el-form ref="form" :model="form" :rules="rules" class="form">
        <el-form-item label="姓名" prop="realName">
          <el-input v-model="form.realName" :maxlength="10" show-word-limit placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model="form.phoneNumber"
                    :disabled="!!id"
                    placeholder="请输入"
                    :maxlength="11"
                    show-word-limit
                    @keyup.native="form.phoneNumber=form.phoneNumber.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="userPosition">
          <el-input v-model="form.userPosition" :maxlength="30" show-word-limit placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPersonnelDetailApi, editPersonnelApi } from '../fetch'
export default {
  name: 'EditDialog',
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
  },
  data () {
    // 手机号校验
    const validPhone = (rules, value, callback) => {
      if (!value) callback()
      if (/^1\d{10}$/g.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确手机号'))
      }
    }
    return {
      dialogVisible: true,
      loading: false,
      btnLoading: false,
      form: {
        realName: '',
        phoneNumber: null,
        userPosition: '',
      },
      rules: {
        realName: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
        ],
        phoneNumber: [
          { required: true, message: '请输入', trigger: ['change', 'blur'] },
          { validator: validPhone, trigger: ['change', 'blur'] },
        ],
      },
    }
  },
  computed: {
    title () {
      return this.id ? '编辑人员' : '添加人员'
    },
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.loading = true
        if (this.id) {
          const res = await getPersonnelDetailApi(this.id)
          this.form = res
        }
      } catch (e) {
        this.$error(e)
      } finally {
        this.loading = false
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        await this.$refs.form.validate()
        this.btnLoading = true
        await editPersonnelApi(this.form)
        this.$success('操作成功')
        this.dialogVisible = false
        this.$emit('close', 'refresh')
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang='scss' scoped>
  .form {
    width: 360px;
  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  ::v-deep .el-dialog{
    margin: auto !important;
    .el-dialog__header{
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #E8E8E8;
      padding: 0 40px 0 30px !important;
      color: #1C1C1C;
      .el-dialog__headerbtn{
        width: 24px;
        height: 24px;
        background: #E8E8E8;
        border-radius: 50%;
      }
    }
    .el-dialog__body{
      display: flex;
      justify-content: center;
      padding: 40px 0 40px !important;
      .el-form-item__label{
        color: #1C1C1C;
      }
      .el-input {
        width: 360px;
      }
    }
    .el-dialog__footer{
      display: flex;
      justify-content: center;
      padding: 0 0 40px;
    }
    .el-input__inner{
      height: 46px;
    }
  }
</style>
